import React from 'react';
import { useStyles } from './styles';
import { Box, Typography } from '@mui/material';
import { Swiper, SwiperSlide } from 'swiper/react';
import P47Logo from '../../../../Assets/images/p47.svg';
import HouseOfCheer from '../../../../Assets/images/HouseOfCheer.svg';
import WizCraft from '../../../../Assets/images/Wizcraft.svg';
import IITMGlobal from '../../../../Assets/images/iitmblue.svg';
import Dangal from '../../../../Assets/images/DangalPartner.svg';
import TurboStart from '../../../../Assets/images/TSPartner.svg';
import YourStory from '../../../../Assets/images/yourStory.svg';
import Zee from '../../../../Assets/images/zeePartner.svg';
import Tapstart from '../../../../Assets/images/tapstart.svg';
import Promena from '../../../../Assets/images/promena.svg';
import Futurism from '../../../../Assets/images/futurism.svg';
import Bandraboy from '../../../../Assets/images/bandraboy.svg';
import design2 from '../../../../Assets/images/design2.svg';
import t2c from '../../../../Assets/images/t2c.svg';
import tap from '../../../../Assets/images/tap.svg';
import houseip from '../../../../Assets/images/houseip.svg';
import alt from '../../../../Assets/images/alt.svg';

import s from '../../../../Assets/images/s.svg';

import { Autoplay } from 'swiper/modules';

import 'swiper/css';

const partnerLogos = [
  { src: HouseOfCheer, name: 'House of Cheer', onclick: () => window.open('https://www.houseofcheer.in/') },
  { src: WizCraft, name: 'WizCraft', onclick: () => window.open('https://www.wizcraftworld.com/') },
  { src: IITMGlobal, name: 'IITM Global', onclick: () => window.open('https://global.iitm.ac.in/') },
  // { src: Dangal, name: 'Dangal', onclick: () => window.open('https://www.ideabaaz.com/') },
  { src: TurboStart, name: 'TurboStart', onclick: () => window.open('https://turbostart.co/') },
  { src: tap, name: 'Tapstartx', onclick: () => window.open('/') },
  { src: houseip, name: 'HouseIP', onclick: () => window.open('/') },

  // { src: design2, name: 'design2', onclick: () => window.open('/') },

  // { src: t2c, name: 't2c', onclick: () => window.open('https://tsquaredc.com/') },

  // { src: alt, name: 'alt', onclick: () => window.open('https://altdash.co/') },

  // { src: s, name: 's', onclick: () => window.open('/') },

  { src: Zee, name: 'Zee', onclick: () => window.open('https://www.zee5.com/') },
];

const LogoCard: React.FC<any> = ({ logo }) => {
  const classes = useStyles();
  return <img src={logo.src} alt="logo" className={classes.logo} onClick={logo.onclick} />;
};

const Partners = () => {
  const classes = useStyles();
  return (
    <Box className={classes.partners}>
      <Box className={classes.content}>
        <Typography className={classes.heading}>Our Partners:</Typography>
        <Box className={classes.swiperContainer}>
          <Swiper
            style={{ justifyContent: 'center' }}
            spaceBetween={50}
            slidesPerView={5}
            loop={true}
            speed={2500} // 👈
            autoplay={{
              delay: 0,
              pauseOnMouseEnter: true,
              disableOnInteraction: false,
            }}
            modules={[Autoplay]}
            breakpoints={{
              320: {
                slidesPerView: 1.6,
              },
              430: {
                slidesPerView: 2,
              },
              608: {
                slidesPerView: 3,
              },
              1024: {
                slidesPerView: 4,
              },
              1280: {
                slidesPerView: 5,
              },
            }}
          >
            {partnerLogos.map((logo, idx) => (
              <SwiperSlide key={idx}>
                <LogoCard logo={logo} />
              </SwiperSlide>
            ))}
            ...
          </Swiper>
        </Box>
      </Box>
    </Box>
  );
};

export default Partners;
